const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Switch+Country+API

function switchCountry(switchToCountry, languageCode) {
    const url = '/api/users/profile/switchCountry';
    return ufeApi.makeRequest(url, {
        method: 'PUT',
        body: JSON.stringify({ switchToCountry, languageCode })
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = switchCountry;
